import { DatePipe } from "@angular/common";

import { IOptionLabel } from "../popover-dropdownlist/popover-dropdownlist.component";
import { DataType } from "../../enums/datatype.enum";

export class JsonUtil {

  datePipe: DatePipe;

  constructor(datePipe?: DatePipe) {
    this.datePipe = datePipe;
  }

  static isJSON(valor: string): boolean {
    try {
      JSON.parse(valor);
    } catch (e) {
        return false;
    }
    return true;
  }

  static procurarPropriedadeAninhada(objeto: any, propriedade: string): any {
    try {
      if ( propriedade.indexOf('.') >= 0 ) {

        const atributo: string[] = propriedade.split('.');
        let objetoTemp = objeto;
        const atributoLength = atributo.length;

        for ( let i = 0; i < atributoLength; i++ ) {
          objetoTemp = objetoTemp[atributo[i]];

          // ultima propriedade, retornar valor
          if ( i === atributoLength - 1) {
            return objetoTemp;
          }
        }
      }
      else {
        return objeto[propriedade];
      }
    }
    catch(e) {
      console.error('Não foi possível encontrar a propriedade ' + propriedade)
    }

    return null;
  }

  parseOptionLabel(texto: string, dataType: DataType) {
    if ( DataType.DATE === dataType ) {
      if ( this.datePipe ) {
        return this.datePipe.transform(texto, 'dd/MM/yyyy');
      }
      else {
        console.error('Instancie o JsonUtil com uma instância do DatePipe para transformação de datas.');
        return texto;
      }
    }
    else {
      return texto;
    }
  }

  getOptionsLabel(objeto: any, optionLabels: IOptionLabel[]): any {
    try {
      let objetosEncontrados = [];

      for ( let optionLabel of optionLabels ) {
        if ( optionLabel.propriedade.indexOf('.') >= 0 ) {

          const atributo: string[] = optionLabel.propriedade.split('.');
          let objetoTemp = objeto;
          const atributoLength = atributo.length;

          for ( let i = 0; i < atributoLength; i++ ) {
            objetoTemp = objetoTemp[atributo[i]];

            // ultima propriedade, retornar valor
            if ( i === atributoLength - 1) {
              objetosEncontrados.push(this.parseOptionLabel(objetoTemp, optionLabel.dataType));
            }
          }
        }
        else {
          objetosEncontrados.push(this.parseOptionLabel(objeto[optionLabel.propriedade], optionLabel.dataType));
        }
      }

      if ( objetosEncontrados.length === 1 ) {
        return objetosEncontrados[0];
      }
      else if ( objetosEncontrados.length >= 1 ) {
        let labelRetorno = '';
        for ( let objetoEncontrado of objetosEncontrados ) {
          if ( labelRetorno ) {
            labelRetorno += ' - ';
          }
          labelRetorno += '' + objetoEncontrado;
        }
        return labelRetorno;
      }

    }
    catch(e) {
      console.error('Não foi possível encontrar a propriedade ' + ( optionLabels ? JSON.stringify(optionLabels) : '' ));
    }

    return null;
  }


}
